<template>
    <div class="sum-itm">
        <div class="progress">
            <div class="progress-bar progress-bar-success transition" :class="`w-custom-${cords.width_1}`">
                <p class="count-perc">
                    <span class="sr-onl">{{cords.width_1}}%</span>
                </p>
            </div>
            <div class="progress-bar progress-bar-primary transition" :class="`w-custom-${cords.width_2}`">
                <p class="count-perc">
                    <span class="sr-onl">{{cords.width_2}}%</span>
                </p>
            </div>
            <div class="progress-bar progress-bar-danger transition" :class="`w-custom-${cords.width_3}`">
                <p class="count-perc">
                    <span class="sr-onl">{{cords.width_3}}%</span>
                </p>
            </div>
            <!-- <div class="progress-bar progress-bar-success transition" style="width: 0; transition: width 0.6s ease" :style="style_1">
                <p class="count-perc">
                    <span class="sr-onl">{{cords.width_1}}</span>
                </p>
            </div>
            <div class="progress-bar progress-bar-info transition" style="width: 0; transition: width 0.6s ease" :style="style_2">
                <p class="count-perc">
                    <span class="sr-onl">{{cords.width_2}}</span>
                </p>
            </div>
            <div class="progress-bar progress-bar-danger transition" style="width: 0; transition: width 0.6s ease" :style="style_3">
                <p class="count-perc">
                    <span class="sr-onl">{{cords.width_3}}</span>
                </p>
            </div> -->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'progress-bar-custom',
        data() {
            let cords = {
                width_1: '35',
                width_2: '30',
                width_3: '35'
            }
            return {
                cords
                // cords: {
                //     width_1: 0,
                //     width_2: 0,
                //     width_3: 0
                // }
            }
        },
        // computed: {
        //     style_1() {
        //         console.log(this.cords)
        //         return {
        //             transition: 'width 0.6s ease',
        //             width: this.cords.width_1
        //         }
        //     },
        //     style_2() {
        //         return {
        //             transition: 'width 0.6s ease',
        //             width: this.cords.width_2
        //         }
        //     },
        //     style_3() {
        //         return {
        //             transition: 'width 0.6s ease',
        //             width: this.cords.width_3
        //         }
        //     },
        //     progress_bar_1() {
        //         return {
        //             transition: 'width 0.6s ease',
        //             width: this.cords.width_1,
        //         }
        //     },
        //     progress_bar_2() {
        //         return {
        //             transition: 'width 0.6s ease',
        //             width: this.cords.width_2,
        //         }
        //     },
        //     progress_bar_3() {
        //         return {
        //             transition: 'width 0.6s ease',
        //             width: this.cords.width_3,
        //         }
        //     }
        // },
        // created() {
        //     this.cords = {
        //         width_1: '35%',
        //         width_2: '30%',
        //         width_3: '35%'
        //     }
        // }
    }
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/_variables";
.transition {
    transition: width 0.6s ease
}
.progress_bar_1, .progress_bar_2, .progress_bar_3 {
    transition: width 0.6s ease
}
.sum-itm .progress {
    margin-bottom: 0;
    margin-top: 50px;
    height: 15px;
    border-radius: 0;
    box-shadow: none;
    overflow: inherit;
}

.progress {
    overflow: hidden;
    height: 20px;
    margin-bottom: 20px;
    background-color: #f5f5f5;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
    -moz-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
    -ms-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
    -o-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
    box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
}


.sum-itm .progress-bar {
    box-shadow: none;
    position: relative;
}


.progress-bar {
    float: left;
    width: 0;
    height: 100%;
    font-size: 12px;
    line-height: 20px;
    color: #fff;
    text-align: center;
    // background-color: #337ab7;
    background-color: #fff;
    /* -webkit-box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);
    -moz-box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);
    -ms-box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);
    -o-box-shadow: inset 0 -1px 0 rgba(0,0,0,.15); */
    box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);
    /* -webkit-transition: width .6s ease;
    -moz-transition: width .6s ease;
    -ms-transition: width .6s ease;
    -o-transition: width .6s ease; */
    transition: width .6s ease;
}

.progress-bar-1, .progress-bar-2, .progress-bar-3 {

    transition: width .6s ease;
}

.sum-itm:hover .progress-bar-1, .sum-itm:hover .progress-bar-3 {
  width: 35%;
}

.sum-itm:hover .progress-bar-2 {
  width: 30%;
}

.progress-bar-primary {
    // background-color: #5bc0de;
    // background-color: $primary;
    // background-image: linear-gradient(to right, rgba($primary, 1), rgba($primary, 0.8));
    background: #FDEFD0;
}
.progress-bar-danger {
    // background-color: #d9534f;
    // background-color: $danger;
    // background-image: linear-gradient(to right, rgba($danger, 1), rgba($danger, 0.8));
    background: #45A7B8;
}
.progress-bar-success {
    // background-color: #5cb85c;
    // background-color: $success;
    // background-image: linear-gradient(to right, rgba($success, 1), rgba($success, 0.8));
    background: #E36921;
}

.sum-itm .count-perc span {
    /* position: relative; */
    display: block;
    height: 25px;
    line-height: 24px;
}


.sum-itm .count-perc {
    border-radius: 8px;
    position: absolute;
    width: 56px;
    /* height: 25px; */
    left: 50%;
    padding-top: 5px;
    padding-bottom: 5px;
    /* -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%); */
    transform: translateX(-50%);
    top: -50px;
    z-index: 100;
    color: #fff;
    margin-bottom: 0;
    background-color: #333;
    -webkit-box-shadow: 0 2px 4px 0 rgba(0,0,0,.09);
    -moz-box-shadow: 0 2px 4px 0 rgba(0,0,0,.09);
    -ms-box-shadow: 0 2px 4px 0 rgba(0,0,0,.09);
    -o-box-shadow: 0 2px 4px 0 rgba(0,0,0,.09);
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.09);
}

.sum-itm .count-perc span:before {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #333;
    position: absolute;
    bottom: -8px;
    left: 50%;
    /* -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%); */
    transform: translateX(-50%);
}
</style>
<!--<style lang="scss">
.progress-bar-custom {
    .progress {
        margin-bottom: 0;
        margin-top: 50px;
        height: 10px;
        border-radius: 0;
        box-shadow: none;
        overflow: inherit;
        .progress-bar {
            box-shadow: none;
            position: relative;
            .count-perc {
                position: absolute;
                width: 56px;
                height: 25px;
                left: 50%;
                transform: translateX(-50%);
                top: -50px;
                z-index: 100;
                color: #fff;
                margin-bottom: 0;
                background-color: #333;
                -webkit-box-shadow: 0 2px 4px 0 rgba(0,0,0,.09);
                -moz-box-shadow: 0 2px 4px 0 rgba(0,0,0,.09);
                -ms-box-shadow: 0 2px 4px 0 rgba(0,0,0,.09);
                -o-box-shadow: 0 2px 4px 0 rgba(0,0,0,.09);
                box-shadow: 0 2px 4px 0 rgba(0,0,0,.09);
                span {
                    position: relative;
                    display: block;
                    height: 25px;
                    line-height: 24px;
                    &::before {
                        content: "";
                        display: block;
                        width: 0;
                        height: 0;
                        border-left: 8px solid transparent;
                        border-right: 8px solid transparent;
                        border-top: 8px solid #333;
                        position: absolute;
                        bottom: -8px;
                        left: 50%;
                        transform: translateX(-50%);
                    }
                }
            }
        }
    }
    // .progress-bar-1, .progress-bar-2, .progress-bar-3 {
    //     transition: width .6s ease;
    // }

    // &:hover .progress-bar-1, &:hover .progress-bar-3 {
    //     width: 35%;
    // }

    // &:hover .progress-bar-2 {
    //     width: 30%;
    // }
}

.progress {
    overflow: hidden;
    height: 20px;
    margin-bottom: 20px;
    background-color: #f5f5f5;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
    -moz-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
    -ms-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
    -o-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
    box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
} 

.progress-bar {
    float: left;
    width: 0;
    height: 100%;
    font-size: 12px;
    line-height: 20px;
    color: #fff;
    text-align: center;
    background-color: #337ab7;
    box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);
    transition: width .6s ease;
}

.progress-bar-info {
    background-color: #5bc0de;
}
.progress-bar-danger {
    background-color: #d9534f;
}
.progress-bar-success {
    background-color: #5cb85c;
}
</style>-->